export default {"src":"/_next/static/media/logo.c65e1434.svg","height":278,"width":433,"blurWidth":0,"blurHeight":0};